import { GUITAR_STRING_MIDIS, mod, noteNameForPc, notePc } from "./notes.js";

export function renderGuitarDiagram(container, voicing, options = {}) {
  if (!container) {
    return;
  }

  if (!voicing) {
    const empty = document.createElement("p");
    empty.className = "guitar-empty";
    empty.textContent = options.emptyText || "No guitar fingering found for this chord.";
    container.replaceChildren(empty);
    return;
  }

  const flats = Boolean(options.flats);
  const rootPc = notePc(options.root);
  const onNoteClick = options.onNoteClick || (() => {});
  const openRow = document.createElement("div");
  const neck = document.createElement("div");
  const names = document.createElement("div");
  openRow.className = "open-muted-row";
  neck.className = "guitar-neck";
  names.className = "string-name-row";

  voicing.frets.forEach((fret, index) => {
    const guitarMidi = Number.isInteger(fret) ? GUITAR_STRING_MIDIS[index] + fret : null;
    const guitarNote = guitarMidi === null ? "" : noteNameForPc(guitarMidi, flats);
    const openMuted = fret === 0 ? document.createElement("button") : document.createElement("span");
    openMuted.textContent = fret === "x" ? "x" : fret === 0 ? "o" : "";
    openMuted.classList.toggle("is-played", fret === 0);
    if (fret === 0) {
      openMuted.type = "button";
      openMuted.dataset.midi = String(guitarMidi);
      openMuted.dataset.pitch = guitarNote;
      openMuted.setAttribute("aria-label", `Play open ${guitarNote} string`);
      openMuted.addEventListener("click", () => onNoteClick({ midi: guitarMidi, pitch: guitarNote, element: openMuted }));
    }
    openRow.append(openMuted);

    const guitarString = document.createElement("div");
    guitarString.className = "guitar-string";
    if (Number.isInteger(fret) && fret > 0) {
      const marker = document.createElement("button");
      const visibleFret = Math.min(5, Math.max(1, fret - voicing.startFret + 1));
      marker.type = "button";
      marker.className = "fret-marker";
      marker.classList.toggle("is-root", Number.isInteger(rootPc) && mod(guitarMidi, 12) === rootPc);
      marker.style.top = `${(visibleFret - 0.5) * 20}%`;
      marker.textContent = options.showFingers && voicing.fingers?.[index] ? voicing.fingers[index] : guitarNote;
      marker.dataset.midi = String(guitarMidi);
      marker.dataset.pitch = guitarNote;
      marker.setAttribute("aria-label", `Play ${guitarNote}`);
      marker.addEventListener("click", () => onNoteClick({ midi: guitarMidi, pitch: guitarNote, element: marker }));
      guitarString.append(marker);
    }
    neck.append(guitarString);

    const note = document.createElement("span");
    note.textContent = guitarNote;
    names.append(note);
  });

  container.replaceChildren(openRow, neck, names);
}

export function flashGuitarPitch(container, pitch) {
  container?.querySelectorAll(`[data-pitch="${escapeAttributeValue(pitch)}"]`).forEach((element) => {
    element.classList.remove("is-playing");
    void element.offsetWidth;
    element.classList.add("is-playing");
    window.setTimeout(() => element.classList.remove("is-playing"), 260);
  });
}

function escapeAttributeValue(value) {
  return String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
}

export function simpleVoicing(frets, startFret, notes = []) {
  return { frets, startFret, notes };
}

export function voicingFromFingeringResult(result) {
  if (!result?.strings) {
    return null;
  }

  const stringData = [...result.strings].reverse();
  const frets = stringData.map((entries) => {
    const entry = entries?.[0];
    if (!entry || entry.isMuted) {
      return "x";
    }
    return Number(entry.fretNo) || 0;
  });
  const fingers = stringData.map((entries) => String(entries?.[0]?.symbol || ""));

  return {
    frets,
    fingers,
    startFret: Number(result.firstFret) || 1,
    variation: Number(result.variation) || 1,
    id: result.id,
  };
}
